<div class="container card mt-2" style="min-height: 400px;">


    <mat-tab-group>
        <mat-tab label="Customer Details">
            <div class="container p-4" style=" background-color: white">

                <div class="row ">
                    <div class="col-md-2 col-sm-4">
<div ><img src="assets/customer_avatar.png" style="width: 100px;height: 100px; border-radius: 100px;"></div>
                    </div>
                    <div class="col-md-10 col-sm-8">
                        <h5>Welcome {{registry.customer.firstname}} {{registry.customer.lastname}} </h5>
                        <ul style="list-style: none;padding: 0px;">
                            <li><span style="font-weight: bold"
                                      class="name">First Name : </span><span> {{registry.customer.firstname}}</span>
                            </li>
                            <li><span style="font-weight: bold"
                                      class="name">Last Name : </span><span>{{registry.customer.lastname}}</span>
                            </li>
                            <li><span style="font-weight: bold"
                                      class="name">Email : </span><span>  {{registry.customer.email}}</span></li>

                        </ul>

<div class="mt-5">
                        <h6 style="font-weight: bold;">Account Deletion</h6>
<p>Please click below to request your account info and data to be deleted.</p>
                        <a class="btn btn-warning" (click)="placeDeletionRequest()">Request Account Deletion</a>
</div>
                    </div>
                </div>

            </div>
        </mat-tab>
        <mat-tab label="Shipping Addresses">
            <div class="container p-4 ">
                <h6 *ngIf="registry.customer.addresses.length > 0" i18n>Customer Shipping Addresses</h6>
                <div class="">
                    <ul style="list-style: none;padding: 0px;">
                        <li *ngFor="let address of registry.customer.addresses">
                            <div class="cont">
                                <div class="row mt-2 p-2" style="background-color: #eeeeee">
                                    <div class="col-8">
                                        <div class="name"
                                             style="font-weight: bold;font-size: 15px">{{address.firstname}} {{address.lastname}}</div>
                                        <div style="color:#888;"><i class="fa fa-globe"> </i> {{address.city}}
                                            , {{address.country_id}}
                                        </div>
                                        <div style="color:#888;"><i class="fa fa-phone"> </i> {{address.telephone}}
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </li>
                    </ul>
                </div>


            </div>
        </mat-tab>

        <mat-tab label="Security">
            <div class="p-4">
                <app-password-reset></app-password-reset>
            </div>
        </mat-tab>
    </mat-tab-group>


</div>






